import { theme } from '@chakra-ui/react';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';

import { ActionButtonStyleConfig } from '../types';

export const styleConfig: ActionButtonStyleConfig = {
  baseStyle: {
    display: 'inline-flex',
    appearance: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    position: 'relative',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    outline: 'none',
    py: '3',
    px: '6',
    fontWeight: 'bold',
    height: 'auto',
    border: '0.1',
    borderRadius: 'lg',
    // Stop box shadow from appearing on focus
    ':focus:not(:focus-visible)': {
      outline: 0,
      boxShadow: 'none',
    },
    // show box shadow on focus-visible while using keyboard
    ':focus': {
      outline: 0,
      boxShadow: '0 0 0 1px white, 0 0 0 3px #6691FF',
    },
  },
  sizes: {
    default: {
      fontSize: 'lg',
      height: '12',
    },
    small: {
      py: '2',
      px: '5',
      height: '9',
    },
  },
  variants: {
    primary: (props: StyleFunctionProps) => ({
      ...theme.components.Button.variants?.solid(props),
      bg: 'blue.500',
      color: 'white',
      _hover: {
        bg: 'blue.200',
        _disabled: {
          bg: 'blue.200',
          color: 'blue.50',
        },
      },
      _active: {
        bg: 'blue.800',
      },
      _disabled: {
        bg: 'blue.200',
        color: 'blue.50',
      },
    }),
    secondary: (props: StyleFunctionProps) => ({
      ...theme.components.Button.variants?.outline(props),
      bg: 'white',
      color: 'grey.900',
      borderColor: 'grey.200',
      _hover: {
        color: 'blue.500',
        borderColor: 'blue.500',
        _disabled: {
          bg: 'white',
          color: 'grey.300',
          borderColor: 'grey.200',
        },
      },
      _active: {
        bg: 'grey.50',
        color: 'blue.800',
        borderColor: 'blue.800',
      },
      _disabled: {
        bg: 'white',
        color: 'grey.300',
      },
    }),
    negative: (props: StyleFunctionProps) => ({
      ...theme.components.Button.variants?.solid(props),
      bg: 'red.500',
      borderColor: 'red.500',
      color: 'white',
      _hover: {
        bg: 'red.300',
        borderColor: 'red.300',
        _disabled: {
          bg: 'red.200',
          color: 'red.50',
          borderColor: 'red.50',
        },
      },
      _active: {
        bg: 'red.800',
        borderColor: 'red.800',
      },
      _disabled: {
        bg: 'red.200',
        borderColor: 'red.50',
      },
    }),
  },
  defaultProps: {
    size: 'default',
    variant: 'primary',
  },
};
